<template>
  <el-drawer
    :title="title"
    :visible.sync="visible"
    :direction="direction"
    class="esp-drawer-box"
    :size="size"
    :before-close="handleClose">
    <div class="esp-drawer-content">
      <div class="esp-real-content">
        <el-scrollbar v-if="scrollFalg" style="overflow-x: hidden">
          <div style="margin: 5px">
            <slot>
            </slot>
          </div>
        </el-scrollbar>
        <div v-else style="width: 100%;height: 100%;">
          <div class="inner-box">
            <slot>
            </slot>
          </div>
        </div>
      </div>
      <div class="esp-drawer-fotter">
        <el-button type="text" @click="doRelease" :loading="reloading">{{ releaseName }}</el-button>
        <el-button type="primary" style="margin-left: 40px;" @click="doAction" :loading="loading">{{ okName }}
        </el-button>
        <el-button type="info" style="margin-left: 40px;" @click="doCancel">{{ cancelName }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "EspNewElDrawer",
  data() {
    return {
      visible: false,
      reloading: false, //加载按钮的
      loading: false //加载按钮的
    }
  },
  props: {
    title: {
      type: String,
      default: '标题'
    },
    releaseName: {
      type: String,
      default: '发布'
    },
    direction: {
      type: String,
      default: 'rtl'
    },
    size: {
      type: [String, Number],
      default: '30%'
    },
    scrollFalg: {
      type: Boolean,
      default: false
    },
    okName: {
      type: String,
      default: '确定'
    },
    cancelName: {
      type: String,
      default: '取消'
    },
    showLoading: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    opened() {
      this.visible = true
    },
    handleClose(callback) {
      callback()
    },
    doRelease() {
      if (this.showLoading) {
        this.reloading = true;
      }
      this.$emit('doRelease', result => {
        if (result == true) {
          this.visible = false;
        }
        this.reloading = false;
      });
    },
    doAction() {
      if (this.showLoading) {
        this.loading = true;
      }
      this.$emit('doAction', result => {
        if (result == true) {
          this.visible = false;
        }
        this.loading = false;
      });
    },
    doCancel() {
      this.visible = false;
    },
  }
}
</script>

<style>
.esp-drawer-box .el-drawer__header {
  width: 100%;
  height: 50px;
  padding: 0px 39px 0px 20px !important;
  margin: 0 !important;
  background: #F5F5F5;
  border: 1px solid rgba(231, 231, 231, 1);
}

.esp-drawer-content {
  width: 100%;
  height: calc(100% - 5px);
  position: relative;
}

.esp-drawer-fotter {
  position: absolute;
  width: 100%;
  height: 80px;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 4px 0px rgba(165, 165, 165, 0.5);
}

.esp-real-content {
  width: 100%;
  height: calc(100% - 85px);
}

.inner-box {
  margin: 5px;
  width: calc(100% - 10px);
  height: calc(100% - 15px);
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/EspNewElDrawer.vue